<template>
  <span>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
      color="#429a86"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="innerModelStart"
          prefix="Од"
          clearable
          v-on="on"
          @input="onInput"
          color="teal lighten-2"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="innerModelStart"
        @input="onInputStart"
        no-title
        color="teal lighten-2"
        :max="innerModelEnd"
      />
    </v-menu>
    <v-menu
      ref="menu2"
      v-model="menu2"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
      color="teal lighten-2"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="innerModelEnd"
          prefix="До"
          clearable
          v-on="on"
          @input="onInput"
          color="teal lighten-2"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="innerModelEnd"
        @input="onInput"
        :min="innerModelStart"
        no-title
        color="teal lighten-2"
      />
    </v-menu>
  </span>
</template>
<script>
export default {
  name: 'datetime-range-picker',
  data () {
    return {
      menu: false,
      menu2: false,
      innerModelStart: '',
      innerModelEnd: '',
      allowedDates: []
    }
  },
  methods: {
    onInput () {
      this.menu = this.menu2 = false
      this.$emit('input', [this.innerModelStart, this.innerModelEnd])
      if (typeof this.changeCallback === 'function') {
        this.changeCallback([this.innerModelStart, this.innerModelEnd])
      }
    },
    onInputStart () {
      if (this.innerModelStart > this.innerModelEnd) {
        this.innerModelEnd = ''
      }
      this.onInput()
    }
  },
  props: {
    value: {},
    label: {
      type: String
    },
    changeCallback: {
      type: Function
    }
  }
}
</script>
